export const encodePhoneNumber = (phone: string | undefined | null) => {
    if (phone && phone?.length >= 4) {
        return `********${phone.slice(-4)}`
    }
    return phone

}
export const getFullName = (firstName: any, lastName: any) => [firstName, lastName].filter(x => x).join(" ")